import { createFileRoute, redirect } from '@tanstack/react-router';

import { getPortfolioLayoutQueryOptions } from '~/server/portfolio/query-options.ts';

export const Route = createFileRoute('/portfolios/')({
	loader: async ({ context }) => {
		const portfolios = await context.queryClient.ensureQueryData(getPortfolioLayoutQueryOptions());
		const fallbackPortfolio = portfolios?.at(-1);

		if (fallbackPortfolio) {
			throw redirect({ href: `/portfolios/${fallbackPortfolio.id}` });
		}

		throw redirect({ href: '/dashboard' });
	},
});
